export default __webpack_public_path__ + "static/media/pool-res2.abee300a.jpg";